import type { MobileCardConfig } from "../Tables/CustomTable/CustomTable";
import { COLORS } from "~/utils";

export const EXPIRING_LEASES_MOBILE_CONFIG: MobileCardConfig = {
  headlineKeys: ["tenant", "unit"],
  primaryKeys: ["endDate"],
};

export const EXPIRING_LEASES_BUCKET_HEADER_STYLES = [
  {
    header: {
      background: `${COLORS.crimson_red}14`,
    },
  },
  {
    header: {
      background: `${COLORS.warm_tangerine}14`,
    },
  },
  {
    header: {
      background: `${COLORS.baby_blue}14`,
    },
  },
  {
    header: {
      background: `${COLORS.lime_green}14`,
    },
  },
  {
    header: {
      background: `${COLORS.forest_green}14`,
    },
  },
] as const;
